var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section-collapseable',{attrs:{"default-expanded":"","hide-initial-always":""},scopedSlots:_vm._u([{key:"expanded",fn:function(){return [_c('record-deal')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }